import styled from 'styled-components';

const StyledContainer = styled.div`
	position: relative;
`;

const StyledScrollContainer = styled.div`
	position: relative;
	overflow-y: scroll;

	&::-webkit-scrollbar {
		display: none;
	}

	@property --topFade {
		syntax: '<length>';
		inherits: false;
		initial-value: 0px;
	}
	@property --bottomFade {
		syntax: '<length>';
		inherits: false;
		initial-value: 0px;
	}

	-webkit-mask-image: linear-gradient(
		to bottom,
		transparent 0,
		black var(--topFade),
		black calc(100% - var(--bottomFade)),
		transparent 100%
	);
	mask-image: linear-gradient(
		to bottom,
		transparent 0,
		black var(--topFade),
		black calc(100% - var(--bottomFade)),
		transparent 100%
	);

	-webkit-mask-repeat: no-repeat;
	mask-repeat: no-repeat;

	-webkit-mask-size: 100% 100%;
	mask-size: 100% 100%;

	transition:
		--topFade 300ms ease,
		--bottomFade 300ms ease;
`;

const StyledMask = styled.div`
	position: absolute;
	left: 0;
	right: 0;
	height: 50px;
	pointer-events: none;
	transition: opacity 0.3s ease;
	z-index: 1;
`;

const StyledTopMask = styled(StyledMask)<{
	$show: boolean;
	$maskColor: string;
}>`
	top: -1px;
	background: linear-gradient(
		to bottom,
		${({ $maskColor }) => $maskColor} 0%,
		transparent 100%
	);
	opacity: ${({ $show }) => ($show ? 1 : 0)};
`;

const StyledBottomMask = styled(StyledMask)<{
	$show: boolean;
	$maskColor: string;
}>`
	bottom: -1px;
	background: linear-gradient(
		to top,
		${({ $maskColor }) => $maskColor} 0%,
		transparent 100%
	);
	opacity: ${({ $show }) => ($show ? 1 : 0)};
`;

const StyledScrollbarTrack = styled.div<{ $scrollbarBlackLine?: boolean }>`
	position: absolute;
	top: 0;
	width: 10px;
	background: ${({ $scrollbarBlackLine }) =>
		$scrollbarBlackLine ? 'rgba(0, 0, 0, 0.1)' : 'rgba(255, 255, 255, 0.05)'};
	border-radius: 10px;
	pointer-events: auto;
	padding-top: 2px;
	padding-bottom: 2px;
	padding-left: 2px;
`;

const StyledScrollbarThumb = styled.div<{
	$thumbColor?: string;
	$thumbHoverColor?: string;
	$scrollbarBlackLine?: boolean;
}>`
	position: absolute;
	top: 0;
	left: 2px;
	width: 6px;
	background: ${({ $scrollbarBlackLine, $thumbColor }) =>
		$scrollbarBlackLine ? '#000000' : $thumbColor ?? '#ffffff'};
	border-radius: 10px;
	cursor: pointer;
	transition: background 0.2s ease;

	&:hover {
		background: ${({ $thumbHoverColor }) =>
			$thumbHoverColor ?? 'rgba(255, 255, 255, 0.8)'};
	}
`;

export {
	StyledBottomMask,
	StyledContainer,
	StyledScrollbarThumb,
	StyledScrollbarTrack,
	StyledScrollContainer,
	StyledTopMask,
};
